import { Link } from "react-router-dom";

export default function NavbarMobile({ links, onClose, onCta }) {
  return (
    <div className="lg:hidden border-t border-[#E8DFD8] bg-[#FCFAF8]">
      <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-4">
        {links.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            onClick={onClose}
            className="text-[#2A1C14] text-lg"
            data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
          >
            {l.label}
          </Link>
        ))}
        <button
          onClick={onCta}
          className="btn-primary mt-2 w-full justify-center"
          data-testid="mobile-cta-get-funded"
        >
          Get Funded Today
        </button>
      </div>
    </div>
  );
}
